import "../Css/home.css"

export default function skilldotnull() {
  return (
    <div className='skilldotnull' ></div>
  )
}
